/* GENERATED FILE */
import * as React from 'react';
import Svg, { Rect, Path, Circle } from 'react-native-svg';

import { IconProps } from '../lib';

function SmileySticker(props: IconProps) {
  return (
    <Svg
      id="Raw"
      viewBox="0 0 256 256"
      width={props.size}
      height={props.size}
      {...props}
    >
      <Rect width={256} height={256} fill="none" />
      <Path
        d="M156.21732,219.78606a95.898,95.898,0,1,1,63.57-63.573Z"
        opacity={0.2}
      />
      <Path
        d="M156.21732,219.78606a95.898,95.898,0,1,1,63.57-63.573Z"
        fill="none"
        stroke={props.color}
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth={16}
      />
      <Circle cx={92} cy={108} r={12} />
      <Circle cx={164} cy={108} r={12} />
      <Path
        d="M169.58,151.99735a48.016,48.016,0,0,1-83.15966.00055"
        fill="none"
        stroke={props.color}
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth={16}
      />
    </Svg>
  );
}

export default SmileySticker;
